import useModal from '@hooks/useModal'
import { Styles } from '@types'
import { TableColumnType, Table, Button, Tag } from 'antd'
import { Users } from 'gadjet-v2-types/dist/model'
import { useEffect, useState } from 'react'

import TenantAPI from '@apis/branch/tenant'

import Loading from '@components/molecules/Loading'
import ModalAlert from '@components/molecules/ModalAlert'

import InviteMemberModal from './InviteMemberModal'

type Props = {
  hqId: number
  branchId: number
  visible: boolean
  tenantId: number
  onDone?: () => void
  onClose: () => void
}
export default function TenantMemberModal({ hqId, branchId, tenantId, visible, onClose, onDone }: Props): JSX.Element {
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState<Users[]>([])
  const [inviteModal, onVisibleInviteModal, onCloseInviteModal] = useModal({ visible: false })

  const columns: TableColumnType<Users>[] = [
    { key: 'name', dataIndex: 'name', title: '이름' },
    { key: 'email', dataIndex: 'email', title: '이메일' },
    { key: 'contact', dataIndex: 'contact', title: '전화번호' },
    {
      title: '권한',
      key: 'tenantRoles',
      dataIndex: 'tenantRoles',
      render: (_, { tenantRoles }) => {
        return <Tag color="blue">관리자</Tag>
      },
    },
  ]

  const getTenantUsers = async () => {
    setLoading(true)
    const { data } = await TenantAPI.getTenantUsers(
      { hqId, branchId, tenantId },
      { query: '', current: 1, pageSize: 1000 }
    )
    setUsers(data.users)
    setLoading(false)
  }

  useEffect(() => {
    if (visible) {
      setUsers([])
      getTenantUsers()
    }
  }, [visible])

  return (
    <ModalAlert title="입주사 멤버" visible={visible} onCancel={onClose}>
      <Loading loading={loading}>
        <Table
          dataSource={users}
          columns={columns}
          pagination={false}
          size="small"
          rowKey={({ userId }) => `${userId}`}
          title={() => (
            <div style={styles.title}>
              <Button size="small" onClick={() => onVisibleInviteModal()}>
                새 멤버 초대
              </Button>
            </div>
          )}
          footer={() => {
            return (
              <InviteMemberModal
                hqId={hqId}
                branchId={branchId}
                tenantId={tenantId}
                visible={inviteModal.visible}
                onClose={onCloseInviteModal}
              />
            )
          }}
        />
      </Loading>
    </ModalAlert>
  )
}

const styles: Styles = {
  title: { display: 'flex', justifyContent: 'flex-end' },
}
